var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcButton,{staticClass:"today",on:{"click":_setup.today}},[_vm._v("\n\t"+_vm._s(_setup.t('calendar', 'Today'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }